import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'learnerDashboard.support.pageTitle',
    defaultMessage: 'Help & Support',
    description: 'Title of the support page',
  },
  raiseTicket: {
    id: 'learnerDashboard.support.raiseTicket',
    defaultMessage: 'Raise a ticket',
    description: 'Text for the raise ticket button',
  },
  activeTicketsTitle: {
    id: 'learnerDashboard.support.activeTicketsTitle',
    defaultMessage: 'Active tickets',
    description: 'Title for the active tickets section',
  },
  ticketHistoryTitle: {
    id: 'learnerDashboard.support.ticketHistoryTitle',
    defaultMessage: 'Ticket history',
    description: 'Title for the ticket history section',
  },
  // Table columns
  columnTicket: {
    id: 'learnerDashboard.support.columnTicket',
    defaultMessage: 'Ticket',
    description: 'Ticket column header in the table',
  },
  columnType: {
    id: 'learnerDashboard.support.columnType',
    defaultMessage: 'Type',
    description: 'Type column header in the table',
  },
  columnStatus: {
    id: 'learnerDashboard.support.columnStatus',
    defaultMessage: 'Status',
    description: 'Status column header in the table',
  },
  columnLastUpdated: {
    id: 'learnerDashboard.support.columnLastUpdated',
    defaultMessage: 'Last updated',
    description: 'Last updated column header in the table',
  },
  rowMenu: {
    id: 'learnerDashboard.support.rowMenu',
    defaultMessage: 'Open ticket actions',
    description: 'Aria label for the ticket row actions menu',
  },
  viewTicket: {
    id: 'learnerDashboard.support.viewTicket',
    defaultMessage: 'View ticket',
    description: 'Label for the view ticket button',
  },
  statusActive: {
    id: 'learnerDashboard.support.statusActive',
    defaultMessage: 'Active',
    description: 'Status badge label for active (open or escalated) tickets',
  },
  statusClosed: {
    id: 'learnerDashboard.support.statusClosed',
    defaultMessage: 'Closed',
    description: 'Status badge label for closed tickets',
  },
  // Empty state
  emptyTitle: {
    id: 'learnerDashboard.support.emptyTitle',
    defaultMessage: 'No tickets yet',
    description: 'Title for the empty state',
  },
  emptyDescription: {
    id: 'learnerDashboard.support.emptyDescription',
    defaultMessage: 'You have not raised any support tickets. Click "Raise a ticket" to create one.',
    description: 'Description for the empty state',
  },
  updatedAgo: {
    id: 'learnerDashboard.support.updatedAgo',
    defaultMessage: 'Updated {time}',
    description: 'Last updated time on the active ticket card',
  },
  // Modal
  modalTitle: {
    id: 'learnerDashboard.support.modalTitle',
    defaultMessage: 'Raise a ticket',
    description: 'Title for the raise ticket modal',
  },
  modalSubtitle: {
    id: 'learnerDashboard.support.modalSubtitle',
    defaultMessage: "Tell us what's going on and our team will get back to you within one business day.",
    description: 'Subtitle for the raise ticket modal',
  },
  ticketTitleLabel: {
    id: 'learnerDashboard.support.ticketTitleLabel',
    defaultMessage: 'Title',
    description: 'Label for the ticket title field',
  },
  ticketTitlePlaceholder: {
    id: 'learnerDashboard.support.ticketTitlePlaceholder',
    defaultMessage: 'Issue in short summary',
    description: 'Placeholder for the ticket title field',
  },
  problemTypeLabel: {
    id: 'learnerDashboard.support.problemTypeLabel',
    defaultMessage: 'Ticket Type',
    description: 'Label for the ticket type field',
  },
  ticketDescriptionLabel: {
    id: 'learnerDashboard.support.ticketDescriptionLabel',
    defaultMessage: 'Description (Optional)',
    description: 'Label for the ticket description field',
  },
  issueType: {
    id: 'learnerDashboard.support.issueType',
    defaultMessage: 'Issue',
    description: 'Issue type option',
  },
  bugType: {
    id: 'learnerDashboard.support.bugType',
    defaultMessage: 'Bug',
    description: 'Bug type option',
  },
  featureType: {
    id: 'learnerDashboard.support.featureType',
    defaultMessage: 'Feature',
    description: 'Feature type option',
  },
  otherType: {
    id: 'learnerDashboard.support.otherType',
    defaultMessage: 'Other',
    description: 'Other type option',
  },
  issuePlaceholder: {
    id: 'learnerDashboard.support.issuePlaceholder',
    defaultMessage: 'Describe the issue you are facing in detail...',
    description: 'Placeholder for issue type description',
  },
  bugPlaceholder: {
    id: 'learnerDashboard.support.bugPlaceholder',
    defaultMessage: 'Describe the bug, including steps to reproduce it...',
    description: 'Placeholder for bug type description',
  },
  featurePlaceholder: {
    id: 'learnerDashboard.support.featurePlaceholder',
    defaultMessage: 'Describe the feature request...',
    description: 'Placeholder for feature type description',
  },
  otherPlaceholder: {
    id: 'learnerDashboard.support.otherPlaceholder',
    defaultMessage: 'Describe your concern in detail...',
    description: 'Placeholder for other type description',
  },
  ticketTitleRequired: {
    id: 'learnerDashboard.support.ticketTitleRequired',
    defaultMessage: 'Title is required',
    description: 'Validation error for required title',
  },
  cancel: {
    id: 'learnerDashboard.support.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button text',
  },
  submit: {
    id: 'learnerDashboard.support.submit',
    defaultMessage: 'Submit',
    description: 'Submit button text',
  },
  delete: {
    id: 'learnerDashboard.support.delete',
    defaultMessage: 'Delete',
    description: 'Delete button text',
  },
  ticketAddedSuccess: {
    id: 'learnerDashboard.support.ticketAddedSuccess',
    defaultMessage: 'Ticket added successfully',
    description: 'Success message when a ticket is added',
  },
  somethingWentWrong: {
    id: 'learnerDashboard.support.somethingWentWrong',
    defaultMessage: 'Something went wrong',
    description: 'Error message when an action fails',
  },
  ticketDeletedSuccess: {
    id: 'learnerDashboard.support.ticketDeletedSuccess',
    defaultMessage: 'Ticket deleted successfully',
    description: 'Success message when a ticket is deleted',
  },
  // Confirm delete modal
  deleteConfirmTitle: {
    id: 'learnerDashboard.support.deleteConfirmTitle',
    defaultMessage: 'Delete Ticket',
    description: 'Title for the delete confirmation modal',
  },
  deleteConfirmDescription: {
    id: 'learnerDashboard.support.deleteConfirmDescription',
    defaultMessage: 'This action will permanently delete the ticket and all associated data.',
    description: 'Description for the delete confirmation modal',
  },
  // View ticket
  viewTicketTitle: {
    id: 'learnerDashboard.support.viewTicketTitle',
    defaultMessage: 'Support Ticket',
    description: 'Title for the view ticket page',
  },
  ticketLoadError: {
    id: 'learnerDashboard.support.ticketLoadError',
    defaultMessage: 'Failed to load this ticket. Please try again later.',
    description: 'Error message when a ticket fails to load',
  },
  noMessages: {
    id: 'learnerDashboard.support.noMessages',
    defaultMessage: 'No messages yet. Start a conversation below.',
    description: 'Empty state when there are no messages',
  },
  replyTo: {
    id: 'learnerDashboard.support.replyTo',
    defaultMessage: 'Reply to {name}',
    description: 'Placeholder for the reply input',
  },
  replyAriaLabel: {
    id: 'learnerDashboard.support.replyAriaLabel',
    defaultMessage: 'Reply to ticket',
    description: 'Aria label for the reply prompt box',
  },
  ticketOpened: {
    id: 'learnerDashboard.support.ticketOpened',
    defaultMessage: 'Opened {time}',
    description: 'Ticket opened relative time on details header',
  },
  ticketUpdatedMeta: {
    id: 'learnerDashboard.support.ticketUpdatedMeta',
    defaultMessage: 'Updated {time}',
    description: 'Ticket updated relative time on details header',
  },
  supportStaff: {
    id: 'learnerDashboard.support.supportStaff',
    defaultMessage: 'support',
    description: 'Reply-to placeholder name when ticket is assigned to support staff',
  },
  supportBadge: {
    id: 'learnerDashboard.support.supportBadge',
    defaultMessage: 'Support',
    description: 'Badge label shown next to support staff messages',
  },
  backToTickets: {
    id: 'learnerDashboard.support.backToTickets',
    defaultMessage: 'Back to Tickets',
    description: 'Back navigation label',
  },
  viewLoading: {
    id: 'learnerDashboard.support.viewLoading',
    defaultMessage: 'Loading',
    description: 'Screen reader text shown while a support ticket is loading',
  },
});

export default messages;
